import {
  AdvancedSearchControl,
  QuickFilterPanel,
  getSetTranslateAdvancedSearch,
} from '@ingenico/react-ui/advanced-search';
import { ListViewHeader } from '@ingenico/react-ui/datagrid';
import { SearchBarInput } from '@ingenico/react-ui/search-bar-input';
import { DEFAULT_LNGS_NAMESPACE, LNGS_NAMESPACE_RESOURCES } from '@ingenico/util-i18n-config';
import { Box } from '@mui/material';
import type { ReactNode } from 'react';
import type { ResourcesListVMOutput } from '../resources-list/ResourcesList.model';
import styles from './ResourcesListFilters.module.scss';

export function ResourcesListFilters({
  advancedSearch,
  quickFiltersSearch,
  t,
}: Pick<ResourcesListVMOutput, 'advancedSearch' | 'quickFiltersSearch' | 't'>): ReactNode {
  const { quickFilterPanelTexts, advancedControlTexts } = getSetTranslateAdvancedSearch(t);

  return (
    <ListViewHeader
      leftSlot={
        <Box className={styles.leftSlot__box}>
          <SearchBarInput
            onSearchChange={advancedSearch.handleSearchQueryChange}
            placeholder={t(`${DEFAULT_LNGS_NAMESPACE.COMMON}:search.placeholder`)}
            variant="filled"
          />
          <AdvancedSearchControl
            ref={quickFiltersSearch.filterRefApi}
            fields={quickFiltersSearch.fields}
            getFilterConditionLabel={(filter) => `${t(filter.field)} ${String(filter.criteria)}`}
            getOperatorsLabel={(operator) => t(`common:advancedSearch.conditionValues.${operator}`)}
            {...advancedControlTexts}
            getQuickFilterLabel={quickFiltersSearch.getLabelQuickFilterLabel}
            isLoading={quickFiltersSearch.isLoading}
            isQuickFilterLoading={quickFiltersSearch.isQuickFilterLoading}
            onQuickFilterChange={quickFiltersSearch.handleQuickFilterChange}
            overrideDefaultFilterTypes={quickFiltersSearch.overrideDefaultFilterTypes}
            quickFiltersOptionListRequests={quickFiltersSearch.quickFiltersOptionListRequests}
            overrideResetFieldType={quickFiltersSearch.overrideResetFieldType}
            advancedSearchProposals={[]}
            i18nNamespaces={[LNGS_NAMESPACE_RESOURCES.DEFAULT]}
            quickFilters={quickFiltersSearch.quickFilters}
          >
            <QuickFilterPanel
              key={quickFiltersSearch.key}
              {...quickFilterPanelTexts}
              quickFilterParamsTexts={{
                uncheckButtonLabel: '',
                checkStatusButtonLabel: '',
                preferencesViewsDefaultViewNamesAllLabel: '',
              }}
            />
          </AdvancedSearchControl>
        </Box>
      }
      leftSlotClassName={styles.listView__leftSlotClassName}
    />
  );
}
